import React from 'react';

import { Divider, Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.secondary.main,
    width: '100%',
  },
  container: {
    maxWidth: '998px',
    display: 'flex',
    justifyContent: 'center',
    margin: '0 auto',
  },
}));

export default function Heading({ text, fontWeight, color }) {
  const classes = useStyles();
  return (
    <Box
      display='flex'
      flexDirection='row'
      alignItems='center'
      justify='center'
      flexWrap='wrap'>
      <Box
        component='span'
        textAlign='center'
        fontWeight={fontWeight || 200}
        color={color || '#323232'}
        mb={1}
        fontSize={25}>
        {text}
      </Box>
      <Box flexGrow={1} ml={1}>
        <Divider className={classes.root} />
      </Box>
    </Box>
  );
}
